// extracted by mini-css-extract-plugin
module.exports = {"card":"TradingPrevMonthsWidget_card__aQadh","datepicker":"TradingPrevMonthsWidget_datepicker__3i1ar","chartArea":"TradingPrevMonthsWidget_chartArea__1DwOQ"};